const state = {
  classifications: ['Pre-Made', 'Customized']
};

export default {
  namespaced: true,
  state,
  actions: {
    fetchClassification({ commit }, payload) {}
  }
};
